/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ProjectController } from 'controllers/Project/ProjectController'
import { ShowException } from 'store/Application/appActions'

export const downloadProjectDeliveryDateEstimation = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'project/download-project-delivery-date-estimation',
  async (payload: { projectId?: string } = { projectId: null }, thunkAPI) => {
    const projectController = new ProjectController(
      payload.projectId || thunkAPI.getState().project.activeProject?.id
    )

    try {
      return await projectController.DownloadProjectDeliveryTimeEstimation()
    } catch (err) {
      ShowException('delivery time estimation', err)
      return thunkAPI.rejectWithValue(err)
    }
  }
)
